<template>
  <div class="rd">
    <slot />
  </div>
</template>

<script>
export default {
  name: "DefaultLayout"
};
</script>

<style scoped lang="scss">
.rd {
  height: 100vh;
  width: 100%;
  position: relative;
  overflow-y: scroll;

  > div {
    height: 100%;
    width: 100%;
  }
}
</style>
